export function convertRGBAToHexColor(rgbaValues) {
    let alpha = rgbaValues[3] || 0o1;
    let hex = rgbaValues
        ? (rgbaValues[0] | (1 << 8)).toString(16).slice(1) +
          (rgbaValues[1] | (1 << 8)).toString(16).slice(1) +
          (rgbaValues[2] | (1 << 8)).toString(16).slice(1)
        : rgbaValues;

    alpha = ((alpha * 255) | (1 << 8)).toString(16).slice(1);
    hex = '#' + hex + alpha;

    return hex;
}

export function splitRGBAValues(rgbaString) {
    const values = rgbaString.split('(')[1].split(')')[0];
    return values.split(',');
}



// WEBPACK FOOTER //
// ./src/components/pages/theme/theme-utils.js